'use client'

import { cn } from '@algoacademy/design-system/shared/cn'
import { motion } from 'framer-motion'
import Link from 'next/link'

type FeatureCardProps = {
  title: string
  description: string
  href: string
  index: number
  delay?: number
}

export function FeatureCard({ title, description, href, index, delay = 0 }: FeatureCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.6, delay, ease: 'easeOut' }}
      className='group relative h-full rounded-2xl'
    >
      <div
        aria-hidden='true'
        className='pointer-events-none absolute -inset-px rounded-2xl bg-gradient-to-br from-algoprimary/0 via-algoprimary/0 to-algosecondary/0 opacity-0 blur transition-opacity duration-300 group-hover:from-algoprimary/40 group-hover:via-algoprimary/10 group-hover:to-algosecondary/40 group-hover:opacity-100'
      />
      <Link
        href={href}
        className={cn(
          'relative flex h-full flex-col gap-4 rounded-2xl border border-borderPrimary bg-backgroundPrimary p-8 shadow-lg transition-all',
          'hover:border-algoprimary hover:shadow-xl',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary'
        )}
      >
        <span className='font-mono text-algoprimary text-xs tracking-widest'>
          {String(index + 1).padStart(2, '0')}
        </span>
        <h3 className='font-semibold text-3xl text-contentPrimary tracking-tight'>{title}</h3>
        <p className='text-base text-contentSecondary leading-relaxed'>{description}</p>
        <span className='mt-auto pt-4 font-medium text-algoprimary text-sm transition-transform group-hover:translate-x-1'>
          Dowiedz sie wiecej →
        </span>
      </Link>
    </motion.div>
  )
}
